import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { BlurView } from 'expo-blur';
import WeatherDetails from './weather_details';

export default function Sidebar() {

    return (

        <View style={styles.main_wrapper}>
            <BlurView intensity={25} style={[StyleSheet.absoluteFill]}>
                <View style={{ alignItems: 'center', justifyContent: "center" }}>
                    <WeatherDetails />
                </View>

            </BlurView >
        </View>

    )
}

const styles = StyleSheet.create({
    main_wrapper: {
        width: 459,
        height: "100%",
        position: "absolute",
        right: 0,
        backgroundColor: "rgba(49, 54, 56, 0.24)",

    }
})
